
 <!-- <mat-icon style="cursor: pointer;"  [matBadge]="notifyNumber" matBadgeColor="accent" (click)="showAlert()">notifications</mat-icon> -->

    
        
     <nav class="navbar navbar-expand-sm navbar-dark"> 
        <div style="padding: 0px !important;">

            <div class="collapse navbar-collapse" id="mynavbar" >
                <ul class="navbar-nav me-auto">
                    <li class="nav-item dropdown">
                        <a #dropdownToggle class="nav-link" href="javascript:void(0)" id="navbarDropdown" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <mat-icon style="cursor: pointer;"  [matBadge]="notifyNumber" matBadgeColor="accent" >notifications</mat-icon> 
                         </a>
                            
                        <ul class="dropdown-menu dropdown-menu-start custom-dropdown-width" aria-labelledby="navbarDropdown">
                            <li>
                                
                                <div class="border-bottom px-3 py-2 text-center d-flex justify-content-between align-items-center bg-light">
                                    <h6>Notifications</h6>
                                    
                                  </div>
                             </li>
                             <li *ngIf="showDialog" class="px-4 py-3">
                                    <div class="flex-grow-1">
                                        <p>
                                             {{ message }} 
                                        </p>
                                        
                                      </div>
                                      
                                      <div mat-dialog-actions>
                                        <button mat-button (click)="reset()">Reset Password </button>
                                    
                                    </div>
                                    
                            </li>
                            <li *ngIf="!showDialog" class="px-4 py-2 text-center small text-muted bg-light show-whats-new-title">
                                <div class="flex-grow-1">
                                    <p>
                                        No Messages yet.
                                    </p>
                                    
                                  </div>
                            </li>
                            
                            
                        </ul>
                    </li>
                </ul>
            </div> 
        </div>
    </nav>
   


    

 
